goog.provide("shadow.js.shim.module$$mui$material$LinearProgress");
goog.provide("module$shadow_js_shim_module$$mui$material$LinearProgress");
shadow.js.shim.module$$mui$material$LinearProgress = shadow.js.nativeProvides["@mui/material/LinearProgress"] = shadow$bridge("@mui/material/LinearProgress");
module$shadow_js_shim_module$$mui$material$LinearProgress.default = shadow.js.shim.module$$mui$material$LinearProgress;
